import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const MemberList          = () => import('../views/member/MemberList.vue');
const MemberEdit          = () => import('../views/member/MemberEdit.vue');
const MemberView          = () => import('../views/member/MemberView.vue');
const KeywordList         = () => import('../views/member/KeywordList.vue');
const KeywordEdit         = () => import('../views/member/KeywordEdit.vue');
const KeywordView         = () => import('../views/member/KeywordView.vue');
const WebExportList       = () => import('../views/member/WebExportList.vue');
const WebExportEdit       = () => import('../views/member/WebExportEdit.vue');
const WebExportView       = () => import('../views/member/WebExportView.vue');
const MemberImport        = () => import('../views/member/MemberImport.vue');
const WebExportListView   = () => import('../views/member/webExport/WebExportListTable.vue');
const WebExportMemberView = () => import('../views/member/webExport/WebExportMemberView.vue');

let meta: MetaData = {module: 'member'};

let member: RouteRecordRaw[] = [
    {
        name: 'member',
        path: '/member',
        redirect: {name: 'member-list'},
        meta,
    },
    {
        name: 'member-index',
        path: '/member/index',
        redirect: {name: 'member-list'},
        meta,
    },
    //<editor-fold desc="Member">
    {
        name: 'member-list',
        path: '/member/member/list',
        component: MemberList,
        meta,
    },
    {
        name: 'member-add',
        path: '/member/member/add',
        component: MemberEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'member-edit',
        path: '/member/member/edit/id/:id',
        component: MemberEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'member-copy',
        path: '/member/member/copy/copy-id/:copyId',
        component: MemberEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'member-view',
        path: '/member/member/view/id/:id',
        component: MemberView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    //</editor-fold>
    // <editor-fold desc="Keywords">
    {
        name: 'keyword-list',
        path: '/member/keyword/list',
        component: KeywordList,
        meta,
    },
    {
        name: 'keyword-add',
        path: '/member/keyword/add',
        component: KeywordEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'keyword-edit',
        path: '/member/keyword/edit/id/:id',
        component: KeywordEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'keyword-copy',
        path: '/member/keyword/copy/copyId/:copyId',
        component: KeywordEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'keyword-view',
        path: '/member/keyword/view/id/:id',
        component: KeywordView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    // </editor-fold>
    //<editor-fold desc="Web-Export">
    {
        name: 'member-web-export-list',
        path: '/member/web-export/list',
        component: WebExportList,
        meta,
    },
    {
        name: 'member-web-export-add',
        path: '/member/web-export/add',
        component: WebExportEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'member-web-export-edit',
        path: '/member/web-export/edit/id/:id',
        component: WebExportEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'member-web-export-copy',
        path: '/member/web-export/copy/copyId/:copyId',
        component: WebExportEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),
            };
        },
    },
    {
        name: 'member-web-export-view',
        path: '/member/web-export/view/id/:id',
        component: WebExportView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'member-web-export-list-view',
        path: '/member/web-export/export-view/id/:id',
        component: WebExportListView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'member-web-export-member-view',
        path: '/member/web-export/export-member-view/id/:id',
        component: WebExportMemberView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    //</editor-fold>
    //<editor-fold desc="Member Import">
    {
        name: 'member-import',
        path: '/member/import/import',
        component: MemberImport,
        meta,
    },
    //</editor-fold>
    {
        path: '/member/:wildcard*',
        redirect: {name: 'member-list'},
        meta,
    },
];

export default member;